import { Observable } from 'common/barrels/rx';

import { ContainerControl } from 'runtime/controls/containercontrol';
import { ControlArgs } from 'runtime/controls/controlargs';
import { registerBinding } from 'runtime/bindingengine';

import 'runtime/styles/controls/tablecellcontainer.less';

export class TableCellContainer extends ContainerControl {
    private childrenBound = false;

    constructor(args: ControlArgs) {
        super(args);

        this.$element.addClass('control-container tablecellcontainer');

        // the initial states and bindings for visible are controlled by the parent; the metadata and the TableCellContainer template both contain some of this information
        // we can't call Initialize as normal here, as it will apply visible bindings we do not want.
        // our choices are to wipe the metadata and still call initialize, or just do this for now.
        this.isElementEnabled(this.config.isElementEnabled);
    }

    columnIndex() : number {
        return this.config.cell.columnIndex;
    }

    rowIndex() : number {
        return this.config.cell.rowIndex;
    }

    applyEnabledState(value: boolean) {
        this.propagateEnabledStateToChildElements(this.$element, this.writableAgnosticDerivedEnabledState());
    }

    cellVisible(value: boolean) {
        if (value === true && !this.childrenBound) {
            this.bindElements(this.$element.children(), this, this.fieldContext, this.methods);
            this.childrenBound = true;
            this.propagateEnabledStateToChildElements(this.$element, this.writableAgnosticDerivedEnabledState());
        }

        this.$element.conditional(value, x => x.show()).conditional(!value, x => x.hide());
        this.visibilitySubject.next(value);
    }

    resizeStream(): Observable<{}> {
        return this.container.resizeStream();
    }
}

registerBinding('tablecellcontainer', TableCellContainer);